import { capitalizeFirstLetter } from 'commonComponents/FirstLetterCaptial';
import { logoutDispatcher } from 'components/login/dispatcher';
import Logout from 'components/logout/Logout';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
    DropdownToggle,
    Media,
} from "reactstrap";
import Notification from 'components/notification/Notification';
import Avatar from 'react-avatar';
import { Badge, Tooltip } from '@mui/material';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

export default function Header({ }) {
    const loginUser = useSelector(state => state?.authReducer?.data?.user);
    // console.log(loginUser)
    const firstChar = capitalizeFirstLetter(loginUser?.name?.charAt(0));
    const lastChar = capitalizeFirstLetter(loginUser?.name?.charAt(0));


    const dispatch = useDispatch();
    const navigate = useNavigate()
    const notificationList = useSelector((state) => state.notificationReducer);

    const [notificationData, setNotificationData] = useState(notificationList?.data || []);
    const [modal, setModal] = useState(false);
    // const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 820);

    // // Update isSmallScreen state when the window is resized
    // useEffect(() => {
    //     const handleResize = () => {
    //         setIsSmallScreen(window.innerWidth < 820);
    //     };
    //     window.addEventListener('resize', handleResize);

    //     // Clean up the event listener
    //     return () => window.removeEventListener('resize', handleResize);
    // }, []);

    const toggle = () => setModal(!modal);

    useEffect(() => {
        setNotificationData(notificationList?.data || []);
    }, [notificationList]);

    const handleNotification = (e) => {
        e.preventDefault();
        if (toggle) {

            toggle();
        } else {

        }
    };
    const handleLogout = (e) => {
        e.preventDefault();
        try {
            dispatch(logoutDispatcher());

            navigate('/auth/signin')
        } catch (error) {
            console.error('Logout failed:', error);

        }
    };

    const imageUrl = `https://via.placeholder.com/60x60?text=${firstChar}${lastChar}`;
    const role = loginUser?.role;

    const roleNames = {
        'company_admin': 'Company Admin',
        'fluid_handler': 'Fluid Handler',
        'super_admin': 'Super Admin',
        'enterprise_admin': 'Enterprise Admin',
        'zone_admin': 'Regional Admin',
        'regional_admin': 'Regional Admin'
    };

    const getNotificationCount = (count) => {

        if (count > 10) {
            return '10+'
        } else {
            return count;
        }
    }

    // if (isSmallScreen) {
    //     // return null;
    //     return <MobileSidebar1 />;
    // }

    return (
        <>
            <Notification toggle={toggle} modal={modal} />

            <header className="header_container" >
                <div className="header__greeting">
                    Hello, {loginUser?.name}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '18px' }}>
                    <div className="header__notifications" onClick={handleNotification}>
                        <Badge badgeContent={getNotificationCount(notificationData.length)} color="error">
                            <NotificationsNoneIcon color="white" />
                        </Badge>
                    </div>

                    <UncontrolledDropdown nav>
                        <DropdownToggle nav>
                            <Media className="align-items-center">
                                <div className="header__user">
                                    <Avatar
                                        name={`${firstChar}`}
                                        round={true}
                                        size="38"
                                        color='white'
                                        fgColor="rgb(14, 61, 13)" // Text color
                                        bgColor="white" // Background color
                                        className="header__avatar"
                                        textSizeRatio={1.4}
                                    />
                                </div>
                            </Media>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-arrow" right>
                            <DropdownItem className="noti-title" header tag="div">
                                <h6 className="text-overflow m-0">Welcome!</h6>
                            </DropdownItem>
                            <DropdownItem  >
                                <i className="ni ni-single-02" />
                                <span>{loginUser?.name}</span>
                            </DropdownItem>
                            <DropdownItem  >
                                <i className="fa-solid fa-sitemap"></i>
                                <span>{roleNames[role] ?? ''}</span>
                            </DropdownItem>

                            <DropdownItem divider />
                            <DropdownItem onClick={(e) => handleLogout(e)} >
                                <i className="ni ni-user-run" />
                                <Logout isUserProfile={true} />
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
            </header>
        </>
    );
}
